import { memo } from 'react';
import { colorAlpha } from '../lib/colorAlpha';
import styled from '@emotion/styled';
import { themeFont } from '../lib/themeFont';

import type { ThemeProps } from '@emotion/react';
import type { CSSObject } from '@emotion/styled';

const ActionButton = styled("button")`
  letter-spacing: 1px;
  line-height: 1.25;
  align-items: center;
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 10px;
  padding: 13px 36px;
  text-decoration: none !important;
  transition: all 0.25s;

  background-color: ${({ theme }: ThemeProps): string => theme.fonts.s4.color};

  color: ${({ theme }: ThemeProps): string => theme.colors.background};

  ${themeFont('s6')}

  ${(props: ThemeProps): CSSObject | undefined =>
    props.theme.components.Button} :hover {
    background-color: ${({ theme }: ThemeProps): string => {
      const backgroundColor = theme?.components?.Button?.backgroundColor;
      const color = theme.fonts.s4.color;

      const hex = backgroundColor || color;

      // TODO: possible bug!
      return colorAlpha(hex, '70%');
    }};

    ${(props: ThemeProps): CSSObject | undefined =>
      props.theme.components.ButtonHover}
  }
`;

const LinkButton = ActionButton.withComponent('a');
const InputButton = ActionButton.withComponent('input');

export const ActionButtonInput = memo(InputButton);
export const ActionButtonLink = memo(LinkButton);
export default memo(ActionButton);
